export const CommonAccountStyles = {
    MobileSaveButton: {
        ml:'auto',
        fontSize:15,
        fontWeight:500,
        mt:-8,
        px:2,
        pt:.75,
        pb:1,
        borderRadius:16,
        minWidth:0,
        mb:2,
        display:{xs:'flex',lg:'none'},
    },
    DesktopSaveChanges: {
        py:.5,
        fontSize:'1rem',
        fontWeight:500,
        borderRadius:16,
        display:{xs:'none',lg:'flex'},
    }
}